/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  NgForm,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import {
  FetchData,
  resizeImage,
  UserAccountMessages,
} from "app/shared/generalMethods";
import { GetSalesforceDataService } from "app/services/salesforce-data";
// import { ParentPortalService } from 'app/services/parentPortal.service';
import { AdminProgramService } from "app/services/admin-program.service";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { finalize } from "rxjs";

@Component({
  selector: "create-program",
  templateUrl: "./create-program.component.html",
  styleUrls: ["./create-program.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CreateProgramComponent implements OnInit {
  [x: string]: any;
  @ViewChild("addProgramNgForm") addProgramNgForm: NgForm;
  addProgramForm: FormGroup;
  pageLoader: any;
  pageLoaderText: any;
  userRecord: any;
  todaysDate = moment().format("YYYY-MM-DD");
  communities: any[] = [];
  imageError: boolean = false;
  imagePreviewOrg: string | ArrayBuffer | null = null;
  isEditMode = false;
  programId: string | null = null;
  existingProgramData: any = null;
  programImagePreview: string | ArrayBuffer | null = null;
  isImageUploading = false;
  categories: any[] = [];
  minStartDate: Date;
  uploadPercent: number = 0;
  downloadURL: string = "";
  isUploading: boolean = false;
  daysOfWeek = [
    { name: "Monday", field: "monday" },
    { name: "Tuesday", field: "tuesday" },
    { name: "Wednesday", field: "wednesday" },
    { name: "Thursday", field: "thursday" },
    { name: "Friday", field: "friday" },
    { name: "Saturday", field: "saturday" },
    { name: "Sunday", field: "sunday" },
  ];

  constructor(
    private _fetchData: FetchData,
    private _formBuilder: FormBuilder,
    // private _parentPortalService: ParentPortalService,
    private adminProgramService: AdminProgramService,
    private _snackBar: MatSnackBar,
    public router: Router,
    private route: ActivatedRoute,
    private navigation: Router,
    private _userMessage: UserAccountMessages,
    private _getSalesforceDataService: GetSalesforceDataService,
    private storage: AngularFireStorage
  ) {
    this.userRecord = this._fetchData.data;
    const adminId = localStorage.getItem("adminId");
    if (this.userRecord) {
      this.communities =
        this.userRecord.lstLocations
          .filter((location) => location)
          .map((location) => ({
            key: location.Name,
            value: location.Name,
          })) || [];
    }
  }

  ngOnInit(): void {
    this.renderForm();
    this.loadAdmin();
    this.loadCategories();
    this.minStartDate = new Date();
    this.minStartDate.setHours(0, 0, 0, 0);
    this.route.paramMap.subscribe((params) => {
      this.programId = params.get("id");
      this.isEditMode = !!this.programId;

      if (this.isEditMode) {
        this.loadProgramData();
        this.addProgramForm.get("community").disable();
        this.addProgramForm.get("startDate").disable();
        this.addProgramForm.get("endDate").disable();
        this.addProgramForm.get("availableWaitingSpace").disable();
        this.addProgramForm.get("availableSpace").disable();
        this.addProgramForm.get("programFee").disable();
        this.daysOfWeek.forEach((day) => {
          this.addProgramForm.get(day.field).disable();

          // Disable time inputs if day is checked
          if (this.addProgramForm.get(day.field).value) {
            this.addProgramForm.get(`startTime${day.name}`).disable();
            this.addProgramForm.get(`endTime${day.name}`).disable();
          }
        });
      }
    });
  }
  loadAdmin(): void {
    const adminList = this._fetchData.data?.lstAdministratorData || [];
    if (adminList.length > 0) {
      this.adminData = {
        OrganizationId: adminList[0].Organization__r?.Id,
        Name: adminList[0].Organization__r?.Name,
        OrganizationName: adminList[0].Organization__r?.Organization_Name__c,
        Phone: adminList[0].Organization__r?.Phone_Number__c,
        Address: adminList[0].Organization__r?.Organization_Address__c,
        OrgImage: adminList[0].Organization__r?.Organization_Image__c,
      };
    }
  }
  loadCategories(): void {
    // Assuming categories are available in _fetchData.data.lstProgramCategories or similar
    // Adjust the path based on where your categories are stored
    const categoryList =
      this._fetchData.data?.lstProgramCategories ||
      this._fetchData.data?.lstAllCategories ||
      [];

    if (categoryList.length > 0) {
      this.categories = categoryList.map((category) => ({
        id: category.Id,
        name: category.Name,
        categoryName: category.Category_Name__c || category.Name,
      }));
    } else {
      // Fallback: if categories are nested in program data, extract unique ones
      this.extractCategoriesFromPrograms();
    }
  }

  // Alternative method if categories need to be extracted from program data
  extractCategoriesFromPrograms(): void {
    const programList = this._fetchData.data?.lstPrograms || [];
    const uniqueCategories = new Map();

    programList.forEach((program) => {
      if (program.Category_of_Program__c && program.Category_of_Program__r) {
        uniqueCategories.set(program.Category_of_Program__c, {
          id: program.Category_of_Program__c,
          name:
            program.Category_of_Program__r.Name ||
            `Cat-${program.Category_of_Program__c.substring(0, 8)}`,
          categoryName:
            program.Category_of_Program__r.Category_Name__c ||
            program.Category_of_Program__r.Name,
        });
      }
    });

    this.categories = Array.from(uniqueCategories.values());
  }
  stripHtmlTags(html: string): string {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    let text = div.textContent || div.innerText || "";
    return text.replace(/['"]/g, "").trim();
  }
  onFeeMethodChange(selectedMethod: "program" | "class"): void {
    const programControl = this.addProgramForm.get("applyFeeByProgram");
    const classControl = this.addProgramForm.get("applyFeeByClass");

    if (selectedMethod === "program" && programControl.value) {
      // If program is selected, uncheck class
      classControl.setValue(false);
    } else if (selectedMethod === "class" && classControl.value) {
      // If class is selected, uncheck program
      programControl.setValue(false);
    }
  }
  loadProgramData(): void {
    this.pageLoader = true;
    this.pageLoaderText = "Loading program data...";

    // First try to get data from navigation state
    this.existingProgramData =
      this.router.getCurrentNavigation()?.extras.state?.["programData"];

    if (this.existingProgramData) {
      this.patchFormWithData(this.existingProgramData);
      this.pageLoader = false;
    } else {
      // If not in state, fetch from local data
      this.fetchProgramFromLocalData();
    }
  }

  fetchProgramFromLocalData(): void {
    const programList = this._fetchData.data?.lstPrograms;

    if (programList && Array.isArray(programList)) {
      this.existingProgramData = programList.find(
        (program) => program.Id === this.programId
      );

      if (this.existingProgramData) {
        this.patchFormWithData(this.existingProgramData);
      } else {
        this._snackBar.open("Program not found in local data", "Close", {
          duration: 3000,
        });
        this.router.navigate(["/program-list"]);
      }
    } else {
      this._snackBar.open("No program data available", "Close", {
        duration: 3000,
      });
      this.router.navigate(["/program-list"]);
    }
    this.pageLoader = false;
  }
  async uploadImageToFirebase(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      // Create a unique filename
      const filePath = `program-images/${new Date().getTime()}_${file.name}`;
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, file);

      this.isUploading = true;
      this.uploadPercent = 0;

      // Monitor upload progress
      task.percentageChanges().subscribe((percentage) => {
        this.uploadPercent = Math.round(percentage || 0);
      });

      // Get notified when the download URL is available
      task
        .snapshotChanges()
        .pipe(
          finalize(() => {
            fileRef.getDownloadURL().subscribe({
              next: (url) => {
                this.downloadURL = url;
                this.isUploading = false;
                this.uploadPercent = 0;
                resolve(url);
              },
              error: (error) => {
                console.error("Error getting download URL:", error);
                this.isUploading = false;
                this.uploadPercent = 0;
                reject(error);
              },
            });
          })
        )
        .subscribe({
          error: (error) => {
            console.error("Upload error:", error);
            this.isUploading = false;
            this.uploadPercent = 0;
            reject(error);
          },
        });
    });
  }

  // UPDATED METHOD: Handle image selection with Firebase upload
  async onImageSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];

    // Basic validation
    if (file.size > 5 * 1024 * 1024) {
      this.openSnackBar("Image size must be less than 5MB");
      return;
    }

    if (!file.type.startsWith("image/")) {
      this.openSnackBar("Please select a valid image file");
      return;
    }

    this.isImageUploading = true;

    try {
      // Resize image first
      const resizedFile = await resizeImage(file, 800, 800);

      // Create preview
      const reader = new FileReader();
      reader.onload = () => {
        this.programImagePreview = reader.result as string;
      };
      reader.readAsDataURL(resizedFile);
      const downloadURL = await this.uploadImageToFirebase(resizedFile);

      // Update form with Firebase URL
      this.addProgramForm.patchValue({
        programImage: downloadURL,
      });
      this.openSnackBar("Image uploaded successfully!");
    } catch (error) {
      console.error("Error in image upload process:", error);
      this.openSnackBar("Error uploading image. Please try again.");
      this.programImagePreview = null;
    } finally {
      this.isImageUploading = false;
    }
  }

  patchFormWithData(programData: any): void {
    const communityName =
      this.userRecord.lstLocations.find(
        (loc) => loc.Id === programData.Program_Location__c
      )?.Name || "";
    const applyFeeByProgram = programData.Apply_Fees_By_Program__c || false;
    const applyFeeByClass =
      programData.Apply_Fees_By_Class_Schedule__c || false;

    // Process program image
    let programImage = "";
    if (programData.Program_Image__c) {
      programImage = this.cleanImageUrl(programData.Program_Image__c);
      this.programImagePreview = programImage;
    }

    this.addProgramForm.patchValue({
      programName: programData.Name,
      programDescription: programData.Program_Description__c,
      programCategory: programData.Category_of_Program__c,
      ageGroup: programData.Age_Group__c,
      isActive: programData.Is_Active__c,
      allDayProgram: programData.All_Day_Program__c,

      community: communityName,
      location: programData.Location__c,
      instructor: programData.Instructor__c,

      startDate: programData.Start_Date__c,
      endDate: programData.End_Date__c,

      monday: programData.Monday__c,
      tuesday: programData.Tuesday__c,
      wednesday: programData.Wednesday__c,
      thursday: programData.Thursday__c,
      friday: programData.Friday__c,
      saturday: programData.Saturday__c,
      sunday: programData.Sunday__c,

      startTimeMonday: programData.Start_Time_Monday__c?.substring(0, 5),
      endTimeMonday: programData.End_Time_Monday__c?.substring(0, 5),
      startTimeTuesday: programData.Start_Time_Tuesday__c?.substring(0, 5),
      endTimeTuesday: programData.End_Time_Tuesday__c?.substring(0, 5),
      startTimeWednesday: programData.Start_Time_Wednesday__c?.substring(0, 5),
      endTimeWednesday: programData.End_Time_Wednesday__c?.substring(0, 5),
      startTimeThursday: programData.Start_Time_Thursday__c?.substring(0, 5),
      endTimeThursday: programData.End_Time_Thursday__c?.substring(0, 5),
      startTimeFriday: programData.Start_Time_Friday__c?.substring(0, 5),
      endTimeFriday: programData.End_Time_Friday__c?.substring(0, 5),
      startTimeSaturday: programData.Start_Time_Saturday__c?.substring(0, 5),
      endTimeSaturday: programData.End_Time_Saturday__c?.substring(0, 5),
      startTimeSunday: programData.Start_Time_Sunday__c?.substring(0, 5),
      endTimeSunday: programData.End_Time_Sunday__c?.substring(0, 5),

      availableSpace: programData.Available_Space__c,
      availableWaitingSpace: programData.Available_Space__c,

      programFee: programData.Program_Fee__c,
      subsidizedAmount: programData.Subsidized_Amount__c,
      applyFeeByProgram,
      applyFeeByClass,
      keyOutcome: programData.Key_Outcome__c || "",
      programImage: programImage,
      curriculumOutline: programData.Curriculum_Outline__c || "",

      orgName: programData.Organization_Name__c,
      orgPhone: programData.Organization_Number__c,
      orgAddress: programData.Organization_Address__c,
      OrganizationId: programData.Organization__c,

      cancellationPolicy: this.stripHtmlTags(
        programData.Cancellation_Policy__c
      ),
      paymentTerm: this.stripHtmlTags(programData.Payment_Term__c),
      paymentDisclaimer: this.stripHtmlTags(programData.Payment_Disclaimer__c),

      gainDescription: this.stripHtmlTags(programData.Gain_Description__c),
      notes: this.stripHtmlTags(programData.Notes__c),
    });
  }
  handleImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    console.warn("Image failed to load:", imgElement.src);

    // Set a default image or hide the broken image
    imgElement.style.display = "none";

    // You can also set a placeholder image
    // imgElement.src = 'assets/images/default-program.png';

    // Clear the preview if it's the program image
    this.programImagePreview = null;
    this.addProgramForm.patchValue({ programImage: "" });
  }

  // ADD THIS METHOD TO CLEAN IMAGE URLS
  cleanImageUrl(url: string): string {
    if (!url) return "";

    // Remove HTML tags and extract just the URL
    let cleanUrl = url.replace(/<[^>]*>/g, "").trim();

    // Decode URL encoded characters
    try {
      cleanUrl = decodeURIComponent(cleanUrl);
    } catch (e) {
      console.warn("Could not decode URL:", url);
    }

    // Fix common encoding issues
    cleanUrl = cleanUrl.replace(/&amp;/g, "&");
    cleanUrl = cleanUrl.replace(/%3C\/?a%3E/gi, ""); // Remove encoded <a> tags
    cleanUrl = cleanUrl.replace(/%3C\/?p%3E/gi, ""); // Remove encoded <p> tags

    // Remove any remaining unsafe: prefix
    cleanUrl = cleanUrl.replace(/^unsafe:/, "");

    return cleanUrl;
  }

  renderForm(): void {
    this.addProgramForm = this._formBuilder.group(
      {
        // Basic Information
        programName: ["", [Validators.required]],
        programDescription: ["", [Validators.required]],
        programCategory: ["", [Validators.required]],
        ageGroup: ["", [Validators.required]],
        isActive: [true],
        allDayProgram: [false],

        // Location Information
        community: ["", [Validators.required]],
        location: ["", [Validators.required]],
        instructor: [""],

        // Dates
        startDate: ["", [Validators.required, this.futureDateValidator()]],
        endDate: ["", [Validators.required, this.dateRangeValidator]],

        // Days and Times
        monday: [false],
        tuesday: [false],
        wednesday: [false],
        thursday: [false],
        friday: [false],
        saturday: [false],
        sunday: [false],

        // Monday Times
        startTimeMonday: [""],
        endTimeMonday: [""],

        // Tuesday Times
        startTimeTuesday: [""],
        endTimeTuesday: [""],

        // Wednesday Times
        startTimeWednesday: [""],
        endTimeWednesday: [""],

        // Thursday Times
        startTimeThursday: [""],
        endTimeThursday: [""],

        // Friday Times
        startTimeFriday: [""],
        endTimeFriday: [""],

        // Saturday Times
        startTimeSaturday: [""],
        endTimeSaturday: [""],

        // Sunday Times
        startTimeSunday: [""],
        endTimeSunday: [""],

        // Capacity
        availableSpace: ["", [Validators.required, Validators.min(1)]],
        availableWaitingSpace: ["", [Validators.min(0)]],

        // Fees
        programFee: ["", [Validators.required, Validators.min(0.5)]],
        subsidizedAmount: [""],

        // Policies
        cancellationPolicy: [""],
        paymentTerm: [""],
        paymentDisclaimer: [""],
        keyOutcome: [""],
        programImage: [""],
        curriculumOutline: [""],

        // Additional Information
        gainDescription: [""],
        notes: [""],

        // Registration Rules
        lessThanDays: [""],
        inBetweenDays: [""],
        greaterThanDays: [""],
        percentageLess: [""],
        percentageBetween: [""],
        percentageGreater: [""],
        messageLessThanDays: [""],
        messageInBetweenDays: [""],
        messageGreaterThanDays: [""],
        applyFeeByProgram: [false],
        applyFeeByClass: [false],
      },
      {
        validators: [
          this.atLeastOneDaySelectedValidator,
          this.feeMethodValidator,
        ],
      }
    );

    // Set conditional validators for days and times
    this.setupDayTimeValidators();
  }
  futureDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      const selectedDate = new Date(control.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time part to compare dates only

      if (selectedDate < today) {
        return { pastDate: true };
      }

      return null;
    };
  }

  // Validator to ensure end date is after start date
  dateRangeValidator: ValidatorFn = (
    form: AbstractControl
  ): ValidationErrors | null => {
    const startDate = form.get("startDate")?.value;
    const endDate = form.get("endDate")?.value;

    if (!startDate || !endDate) {
      return null;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    if (end <= start) {
      return { invalidDateRange: true };
    }

    return null;
  };
  feeMethodValidator(form: FormGroup): ValidationErrors | null {
    const applyFeeByProgram = form.get("applyFeeByProgram").value;
    const applyFeeByClass = form.get("applyFeeByClass").value;

    if (!applyFeeByProgram && !applyFeeByClass) {
      return { feeMethodRequired: true };
    }

    if (applyFeeByProgram && applyFeeByClass) {
      return { bothFeeMethodsSelected: true };
    }

    return null;
  }

  atLeastOneDaySelectedValidator(group: FormGroup): ValidationErrors | null {
    const days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    const atLeastOne = days.some((day) => group.get(day)?.value);
    return atLeastOne ? null : { noDaySelected: true };
  }

  setupFeeMethodListeners(): void {
    const programControl = this.addProgramForm.get("applyFeeByProgram");
    const classControl = this.addProgramForm.get("applyFeeByClass");

    programControl.valueChanges.subscribe((value) => {
      if (value) {
        classControl.setValue(false, { emitEvent: false });
      }
    });

    classControl.valueChanges.subscribe((value) => {
      if (value) {
        programControl.setValue(false, { emitEvent: false });
      }
    });
  }

  goBack(): void {
    this.navigation.navigate(["/dashboard"]);
  }

  setupDayTimeValidators(): void {
    this.daysOfWeek.forEach((day) => {
      const dayControl = this.addProgramForm.get(day.field);
      const startTimeControl = this.addProgramForm.get(`startTime${day.name}`);
      const endTimeControl = this.addProgramForm.get(`endTime${day.name}`);

      dayControl.valueChanges.subscribe((isSelected) => {
        if (isSelected) {
          startTimeControl.setValidators([Validators.required]);
          endTimeControl.setValidators([Validators.required]);
        } else {
          startTimeControl.clearValidators();
          endTimeControl.clearValidators();
          startTimeControl.setValue("");
          endTimeControl.setValue("");
        }
        startTimeControl.updateValueAndValidity();
        endTimeControl.updateValueAndValidity();
      });
    });
  }
  onPhoneInput(event: KeyboardEvent): void {
    if (
      !/[0-9]/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Tab"
    ) {
      event.preventDefault();
    }
  }
  onFeeInput(event: KeyboardEvent, value: string): void {
    if (
      !/[0-9]/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Tab" &&
      event.key !== "."
    ) {
      event.preventDefault();
    }

    // Allow only one decimal
    if (event.key === "." && value.includes(".")) {
      event.preventDefault();
    }
  }
  onAgeInput(event: KeyboardEvent, value: string): void {
    if (
      !/[0-9]/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Tab" &&
      event.key !== "-"
    ) {
      event.preventDefault();
    }

    // Allow only one decimal
    if (event.key === "-" && value.includes("-")) {
      event.preventDefault();
    }
  }

  getFormValidationStatus(): any {
    const status: any = {};
    Object.keys(this.addProgramForm.controls).forEach((key) => {
      status[key] = {
        valid: this.addProgramForm.controls[key].valid,
        errors: this.addProgramForm.controls[key].errors,
      };
    });
    return status;
  }

  // onFormSubmit(): void {
  //   if (this.addProgramForm.valid) {
  //     this.pageLoader = true;
  //     this.pageLoaderText =
  //       this._fetchData.data.lstAppSettings[0].Loading_message__c;

  //     const formData = this.prepareProgramData();
  //     const adminId = localStorage.getItem("adminId");

  //     if (this.isEditMode) {
  //       this.updateProgram(formData, adminId);
  //     } else {
  //       this.createProgram(formData, adminId);
  //     }
  //   } else {
  //     this.openSnackBar("Please fill in all required fields correctly.");
  //     this.markFormGroupTouched(this.addProgramForm);
  //   }
  // }

  onFormSubmit(): void {
    if (this.addProgramForm.valid) {
      this.pageLoader = true;
      this.pageLoaderText =
        this._fetchData.data.lstAppSettings[0].Loading_message__c;

      const formData = this.prepareProgramData();
      const adminId = localStorage.getItem("adminId");

      if (this.isEditMode) {
        this.updateProgram(formData, adminId);
      } else {
        this.createProgram(formData, adminId);
      }
    } else {
      // Check specifically for no day selection
      if (this.addProgramForm.errors?.noDaySelected) {
        this.openSnackBar("Please select at least one day for the schedule.");
      } else {
        this.openSnackBar("Please fill in all required fields correctly.");
      }

      this.markFormGroupTouched(this.addProgramForm);
    }
  }

  createProgram(formData: any, adminId: string): void {
    this.adminProgramService.createProgram(formData, adminId).subscribe(
      (response) => {
        const results: any = this._fetchData.parseIntoJSON(response.msg);
        if (results.success) {
          this.openSnackBar("Program created successfully!");
          this._fetchData.setLocalStorage(response.msg);
          this.router.navigate(["/program-list"]);
        } else {
          this.pageLoader = false;
          this.openSnackBar("Error creating program. Please try again.");
        }
      },
      (err) => {
        this.pageLoader = false;
      }
    );
  }
  prepareProgramData(): any {
    const disabledStates = {};
    if (this.isEditMode) {
      const disabledFields = [
        "startDate",
        "endDate",
        "availableWaitingSpace",
        "availableSpace",
        "programFee",
        "community",
        ...this.daysOfWeek.map((day) => day.field),
        ...this.daysOfWeek.flatMap((day) => [
          `startTime${day.name}`,
          `endTime${day.name}`,
        ]),
      ];

      disabledFields.forEach((field) => {
        disabledStates[field] = this.addProgramForm.get(field).disabled;
        this.addProgramForm.get(field).enable();
      });
    }

    const formValue = this.addProgramForm.value;

    // Restore disabled state
    Object.keys(disabledStates).forEach((field) => {
      if (disabledStates[field]) {
        this.addProgramForm.get(field).disable();
      }
    });

    const communityId =
      this.userRecord.lstLocations.find(
        (loc) => loc.Name === formValue.community
      )?.Id || "";

    const getTimeValue = (dayActive: boolean, timeValue: string) => {
      if (!dayActive) return null;
      if (!timeValue) return null;
      return this.formatTime(timeValue);
    };

    const org = this.adminData || {};

    // Set default image if no image is provided
    let programImage = formValue.programImage;

    return {
      Id: this.isEditMode ? this.programId : null,
      Name: formValue.programName,
      Program_Description__c: formValue.programDescription,
      Category_of_Program__c: formValue.programCategory,
      Age_Group__c: formValue.ageGroup,
      Is_Active__c: formValue.isActive,
      All_Day_Program__c: formValue.allDayProgram,
      Key_Outcome__c: formValue.keyOutcome,
      Program_Image__c: programImage,
      Curriculum_Outline__c: formValue.curriculumOutline,

      Program_Location__c: communityId,
      Location__c: formValue.location,
      Instructor__c: formValue.instructor,

      Start_Date__c: moment(formValue.startDate).format("YYYY-MM-DD"),
      End_Date__c: moment(formValue.endDate).format("YYYY-MM-DD"),

      // Days
      Monday__c: formValue.monday,
      Tuesday__c: formValue.tuesday,
      Wednesday__c: formValue.wednesday,
      Thursday__c: formValue.thursday,
      Friday__c: formValue.friday,
      Saturday__c: formValue.saturday,
      Sunday__c: formValue.sunday,

      // Times (corrected mapping)
      Start_Time_Monday__c: getTimeValue(
        formValue.monday,
        formValue.startTimeMonday
      ),
      End_Time_Monday__c: getTimeValue(
        formValue.monday,
        formValue.endTimeMonday
      ),
      Start_Time_Tuesday__c: getTimeValue(
        formValue.tuesday,
        formValue.startTimeTuesday
      ),
      End_Time_Tuesday__c: getTimeValue(
        formValue.tuesday,
        formValue.endTimeTuesday
      ),
      Start_Time_Wednesday__c: getTimeValue(
        formValue.wednesday,
        formValue.startTimeWednesday
      ),
      End_Time_Wednesday__c: getTimeValue(
        formValue.wednesday,
        formValue.endTimeWednesday
      ),
      Start_Time_Thursday__c: getTimeValue(
        formValue.thursday,
        formValue.startTimeThursday
      ),
      End_Time_Thursday__c: getTimeValue(
        formValue.thursday,
        formValue.endTimeThursday
      ),
      Start_Time_Friday__c: getTimeValue(
        formValue.friday,
        formValue.startTimeFriday
      ),
      End_Time_Friday__c: getTimeValue(
        formValue.friday,
        formValue.endTimeFriday
      ),
      Start_Time_Saturday__c: getTimeValue(
        formValue.saturday,
        formValue.startTimeSaturday
      ),
      End_Time_Saturday__c: getTimeValue(
        formValue.saturday,
        formValue.endTimeSaturday
      ),
      Start_Time_Sunday__c: getTimeValue(
        formValue.sunday,
        formValue.startTimeSunday
      ),
      End_Time_Sunday__c: getTimeValue(
        formValue.sunday,
        formValue.endTimeSunday
      ),

      Available_Space__c: formValue.availableSpace,
      Available_Waiting_Space__c: formValue.availableSpace,
      Program_Fee__c: formValue.programFee,
      Subsidized_Amount__c: formValue.subsidizedAmount || formValue.programFee,
      Apply_Fees_By_Program__c: this.addProgramForm.value.applyFeeByProgram,
      Apply_Fees_By_Class_Schedule__c:
        this.addProgramForm.value.applyFeeByClass,

      // Org Details
      Organization_Name__c: org.OrganizationName,
      Organization_Number__c: org.Phone,
      Organization_Address__c: org.Address,
      Community_Image__c: org.OrgImage,
      Organization__c: org.OrganizationId,

      // Policies
      Cancellation_Policy__c: formValue.cancellationPolicy,
      Payment_Term__c: formValue.paymentTerm,
      Payment_Disclaimer__c: formValue.paymentDisclaimer,

      // Additional Info
      Gain_Description__c: formValue.gainDescription,
      Notes__c: formValue.notes,
    };
  }
  updateProgram(formData: any, adminId: string): void {
    this.adminProgramService.updateProgram(formData, adminId).subscribe(
      (response) => {
        const results: any = this._fetchData.parseIntoJSON(response.msg);
        if (results.success) {
          this.openSnackBar("Program updated successfully!");
          this._fetchData.setLocalStorage(response.msg);
          this.router.navigate(["/program-list"]);
        } else {
          this.pageLoader = false;
          this.openSnackBar("Error updating program. Please try again.");
        }
      },
      (err) => {
        this.pageLoader = false;
      }
    );
  }

  formatTime(timeString: string): string {
    if (!timeString) {
      return null;
    }
    return moment(timeString, "HH:mm").format("HH:mm:ss");
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  redirectUserToMaintenancePage(): void {
    this._getSalesforceDataService.redirectUserToMaintenancePage();
  }

  openSnackBar(message: string): void {
    this._snackBar.open(message, "Close", {
      duration: 6000,
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }
  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];

    if (file) {
      if (file.size > 1048576) {
        // 1MB = 1024 * 1024 bytes
        this.imageError = true;
        this.imagePreviewOrg = null;
        this.addProgramForm.patchValue({ orgImage: null });
        return;
      }

      this.imageError = false;

      const reader = new FileReader();
      reader.onload = () => {
        const imageData = reader.result;
        this.addProgramForm.patchValue({ orgImage: imageData });
        this.imagePreviewOrg = imageData;
      };
      reader.readAsDataURL(file);
    }
  }

  // Add method to remove image
  removeImage(): void {
    this.programImagePreview = null;
    this.addProgramForm.patchValue({
      programImage: null,
    });
    this.downloadURL = "";
  }
}
